<template>
  <div class="diagnosis-list">
    <div
      class="diagnosis-item flex items-center gap-1"
      v-for="(diagnosis, i) in diagnoses"
      :key="i"
    >
      <button
        type="button"
        class="cursor-pointer text-lg leading-none opacity-60 hover:opacity-100"
        @click="removeDiagnosis(i)"
        v-if="editable"
        aria-label="Remove diagnosis"
      >
        ×
      </button>
      <CertaintyIcon :certainty="diagnosis.certainty" />
      <div class="item-text">
        {{ diagnosis.text }}
      </div>
      <div class="item-code ml-2 opacity-50">
        {{ diagnosis.code }}
      </div>
      <div class="grow text-right" v-if="editable">
        Certainty:
        <select
          class="select select-xs w-1/2"
          v-model.number="diagnosis.certainty"
          @change="
            () => {
              if ((diagnosis.certainty as number | string) === '') {
                diagnosis.certainty = null;
              }
              $emit('change');
            }
          "
        >
          <option value="">--</option>
          <option :value="5">N/A</option>
          <option :value="1">Possible</option>
          <option :value="2">Probable</option>
          <option :value="3">Almost Certain</option>
          <option :value="4">Certain</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type Diagnosis from "../../types/Diagnosis";
import CertaintyIcon from "./CertaintyIcon.vue";

const props = withDefaults(
  defineProps<{ diagnoses: Diagnosis[]; editable: boolean }>(),
  { editable: false }
);

const emit = defineEmits(["change"]);

function removeDiagnosis(i: number) {
  props.diagnoses.splice(i, 1);
  emit("change");
}
</script>

<style scoped>
.diagnosis-item {
  margin: 5px 0;
}
</style>
